import axios from '@/plugins/axios'
import { auth } from '@/store/auth.module'

class UserService {
  async getUserInfo() {
    const userSeqId = auth.state.user.userSeqId

    const { data } = await axios.get(`/sum/api/users/${userSeqId}`)
    return data
  }

  async putUserInfo(param) {
    const userSeqId = auth.state.user.userSeqId

    const formData = new FormData()
    formData.append('lastName', param.lastName)
    formData.append('firstName', param.firstName)
    formData.append('sex', param.sex)
    formData.append('file', param.file)

    const { data } = await axios.put(`/sum/api/users/${userSeqId}`, formData)
    return data
  }

  async getDashboard() {
    const { data } = await axios.get('/sum/api/dashboard')
    return data
  }

  async sendAuthEmail() {
    const { data } = await axios.get('/sum/api/users/auth')
    return data
  }

  async resetPassword(userId) {
    const { data } = await axios.delete(`/sum/api/password?userId=${userId}`)
    return data
  }

  async getMilestone() {
    const { data } = await axios.get('/sum/api/milestone')
    return data
  }
}

export default new UserService()
